import { forwardRef } from "react";
import { UploadProfile } from "./modal/UploadProfileModal";
import RenderFormWithRef, { FormRenderRef } from "@/components/Form/Renderer/RenderFormWithRef";
import { toastMessage } from "@/utils/helper/myToast";
import { useSelector } from "react-redux";
import { loginSelector } from "@/store/features/loginSlice";
import { MODE } from "@/types/global";

interface ProfileEditProps {
  openModal: (modalKey: string, props?: any) => void;
  formConfig: any;
  data: any;
  updateAndFetchProfile: (data: any) => Promise<void>;
  setIsSubmitting: (value: boolean) => void;
  setMode: (data: MODE) => void;
  updateMyProfile: any;
  profile_key: string;
  nameKey: string;
}

const ProfileEdit = forwardRef<FormRenderRef, ProfileEditProps>(
  ({ openModal, formConfig, data, updateAndFetchProfile, setIsSubmitting, setMode, updateMyProfile, profile_key, nameKey }, ref) => {
    const { currentUser } = useSelector(loginSelector);
    const handleOpenProfileModal = () => openModal("uploadProfileImage", { profileUrl: data?.profile_pic_path, profile_key, updateAndFetchProfile, openModal });

    const handleUpdate = async (data: any) => {
      const { orgType, otherOrgType, ...rest } = JSON.parse(JSON.stringify(data));
      let payload;
      if (orgType) {
        payload = orgType !== "Others" ? { orgType, ...rest } : { orgType, otherOrgType, ...rest };
      } else {
        payload = rest;
      }

      try {
        setIsSubmitting(true);
        const res: any = await updateMyProfile({ ...payload, signupType: currentUser?.userType });
        if (res?.status === 200) {
          const { message, isError, showMessage } = res.data;
          setMode("view");
          return showMessage && toastMessage(message, isError);
        } else {
          console.log("Error", res);
          const { message, isError } = res?.response?.data || {};
          if (message) {
            return toastMessage(message, isError);
          }
          if (res.message) {
            return toastMessage(res.message, true);
          }
        }
      } catch (err) {
        console.log({ err });
      } finally {
        setIsSubmitting(false);
      }
    };

    return (
      <div>
        <UploadProfile name={data[nameKey]} profileUrl={data[profile_key]} handleOnClick={handleOpenProfileModal} />
        <RenderFormWithRef handleFormSubmit={handleUpdate} formConfig={formConfig} className="p-1 md:p-4" formClassName="" ref={ref} formData={data} />
      </div>
    );
  }
);

export default ProfileEdit;
